export default __webpack_public_path__ + "static/media/corner.9f6a6299.svg";